module.exports = __webpack_public_path__ + "media/tharki.9a810771.mp3";